import React from "react";
// import heading from "../assets/images/heading.png";
// import doctorsicon from "../assets/images/doctorsicon.png";
// import medicalrecords from "../assets/images/medicalrecords.png";
// import logout from "../assets/images/logout.png";
// import editicon from "../assets/images/editicon.png";
// import healthprofile from "../assets/images/healthprofile.jpg";
// import consulthistory from "../assets/images/consulthistory.jpg";
// import body_temp from "../assets/images/body_temp.png";
// import heart_rate from "../assets/images/heart_rate.png";
// import blood_sugar from "../assets/images/blood_sugar.png";
// import blood_pressure from "../assets/images/blood_pressure.png";
// import loginImg from "../assets/images/loginImg.jpg";
// import signin from "../assets/images/signIn.png";
import customerSupport from "../assets/images/customerSupport.jpg";
import doctors from "../assets/images/doctors.jpg";
import MedicalRecord from "../assets/images/MedicalRecord.jpg";
import medicalGraph from "../assets/images/medicalGraph.jpg";

import {
  CarouselProvider,
  Slider,
  Slide,
  Dot,
} from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import appIcon from "../assets/images/appIcon_round.webp";

const LandingPage = () => {
  const navigate = useNavigate();
  const [msg, setMsg] = useState("");
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  console.log("My currentSlideIndex Index::",currentSlideIndex);

  const sliderData = [
    {
      id: 1,
      image: doctors,
      Btext: "Doctors",
      text: "examine patients and take medical histories and prescribe medications and order, perform, and interpret diagnostic tests",
    },
    {
      id: 2,
      image: MedicalRecord,
      Btext: "Medical records",
      text: "a collection of documents that contain a patient's health history and treatment information",
    },
    {
      id: 3,
      image: customerSupport,
      Btext: "Customer support",
      text: "a team of people who help customers with a company's products or services.",
    },
    {
      id: 4,
      image: medicalGraph,
      Btext: "Medical health graph",
      text: "An instrument used to record the electrical activity of the heart, typically using an electrocardiogram (ECG)",
    },
  ];
  const accessHandeler = () => {
    setMsg("Click on Sign In for accessing items");
    setTimeout(() => {
      setMsg("");
    }, 3000);
  };

  const signInHandeler = () => {
    navigate("/SignUp");
  };

  const logInHandeler = () => {
    navigate("/Login");
  };
  let id = localStorage.getItem("patientid");

  let tableData = [
    {
      Reading: "100",
      create_date: "03.01.2023",
    },
    {
      Reading: "40",
      create_date: "06.04.2023",
    },
    {
      Reading: "90",
      create_date: "09.07.2023",
    },
  ];

  const styles = {
    slideContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      width: "100%", // Full width
      padding: "5px",
      boxSizing: "border-box", // Ensures padding doesn't affect width
      textAlign: "center",
    },
    image: {
      width: "310px", // Ensure width and height are equal
      height: "350px",
      objectFit: "fill",
      borderRadius: "5%",
      // border: "2px solid  #ffffff", // Optional border for styling
      boxShadow:
      "0px 4px 6px rgba(0, 0, 0, 0.3), 0px 1px 3px rgb(171, 234, 253)", // 3D shadow effects
      marginTop: 30,
    },
    text: {
      marginTop: "2px",
      fontSize: "18px",
      color: "#636363",
      width: "80%",
      textAlign: "left",
      fontWeight: "400",
    },
    textBold: {
      marginTop: "15px",
      fontSize: "22px",
      color: "#00b9ff",
      fontWeight: "bold",
    },
    dotsContainer: {
      display: "flex",
      justifyContent: "center",
      gap: "10px", 
      marginTop: "-15px",
    },
    dot: {
      width: "20px",
      height: "3px",
      borderRadius: "15px", 
      backgroundColor: "#9ef8fe", 
      border: "none",
      outline: "none",
      cursor: "pointer",
    },
    activeDot: {
      backgroundColor: "#9ef8fe", 
    },
  };
  return (
    <div className="background-container">
       <div>
            <img
              src={appIcon}
              style={{ height: 100, width: 100, marginTop: 5 }}
            />
          </div>
     <CarouselProvider
        naturalSlideWidth={100}
        naturalSlideHeight={150}
        totalSlides={sliderData.length}
        currentSlide={currentSlideIndex}
        onChange={(newIndex) => console.log(newIndex)
        }
      >
        <Slider>
          {sliderData.map((slide) => (
            <Slide key={slide.id} index={slide.id - 1}>
              <div style={styles.slideContainer}>
                <img
                  src={slide.image}
                  alt={`Slide ${slide.id}`}
                  style={styles.image}
                />
                <p style={styles.text}>
                  <p style={styles.textBold}>{slide.Btext}</p>
                  {slide.text}
                </p>
              </div>
            </Slide>
          ))}
        </Slider>
        <div style={styles.dotsContainer}>
          {sliderData.map((slide, index) => (
            <Dot
              key={slide.id}
              slide={index}
              style={{
                ...styles.dot,
                ...(index === currentSlideIndex && styles.activeDot), // Default first dot active
              }}
              className="dot"
            />
          ))}
        </div>
        <div
          style={{
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",

          }}
        >
          <button
            className="signin_button"
            onClick={() => {
              signInHandeler();
            }}
          >
            Sign up
          </button>
          <button
            className="signin_button"
            onClick={() => {
              logInHandeler()
            }}
          >
            Sign In
          </button>
        </div>

      </CarouselProvider>
    </div>
  );
};

export default LandingPage;
